module.exports = __webpack_public_path__ + "img/亞太電信.19422344.png";